// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"21d33960","587":"cf3e6397","822":"5149c728","835":"26057a96"}[chunkId] + ".chunk.js";
};